export default {
  default: {
    goBack: 'Go Back',
    title: 'Calendar',
  },
}
